import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../../services/supabaseClient';

const DetailBerita = () => {
  const { id } = useParams();
  const [berita, setBerita] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDetailBerita = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from('berita')
          .select('*')
          .eq('id', id)
          .single();

        if (error) {
          throw error;
        }

        setBerita(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      fetchDetailBerita();
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex justify-center items-center">
        <p className="text-lg text-slate-500">Memuat detail berita...</p>
      </div>
    );
  }

  if (error || !berita) {
    return (
      <div className="min-h-screen bg-slate-50 flex flex-col justify-center items-center px-4 text-center">
        <p className="text-xl text-red-600 font-semibold mb-4">Gagal memuat berita: {error || 'Berita tidak ditemukan'}</p>
        <Link to="/" className="text-emerald-600 hover:underline">Kembali ke Beranda</Link>
      </div>
    );
  }

  const imageUrl = berita.gambar || berita.image_url || berita.gambar_url;

  return (
    <div className="bg-slate-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        {imageUrl && (
          <div className="w-full h-64 md:h-96 bg-slate-200">
            <img 
              src={imageUrl} 
              alt={berita.judul || 'Detail Berita'} 
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <div className="p-8 md:p-12">
          <div className="mb-6 flex flex-wrap items-center gap-4 text-sm text-slate-500">
            <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full font-medium">
              {berita.kategori || 'UPDATE KEGIATAN'}
            </span>
            <span>
              {berita.created_at ? new Date(berita.created_at).toLocaleDateString('id-ID', { 
                weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' 
              }) : 'Tanggal tidak tersedia'}
            </span>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
            {berita.judul || berita.title || 'Tanpa Judul'}
          </h1>
          
          <div className="prose prose-emerald max-w-none text-slate-700 whitespace-pre-wrap leading-relaxed">
            {berita.deskripsi || berita.konten || berita.isi_berita || berita.content || 'Konten berita belum tersedia.'}
          </div>
          
          <div className="mt-12 pt-8 border-t border-slate-100">
            <Link to="/" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700 transition-colors">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
              Kembali ke Beranda
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailBerita;
